<!-- NO USED YET, NEEDS TO BE TESTED WHEN USED. -->
<div class="field-wrapper" [formGroup]="formGroup">
  
  <div class="field-label">
    <label class="mb-0" style="font-weight: 500;">
      {{field.label}}:
    </label>
  </div>
  
  <div valign="middle" class="checkbox-tree-container">
    <section class="example-section">
      <ul style="list-style: none; padding-left: 0; margin: 0;">
        <ng-container *ngFor="let item of choices">
          <ng-container *ngTemplateOutlet="rootItem; context: {$implicit: item}"></ng-container>
        </ng-container>
      </ul>
    </section>
  </div>
</div>

<ng-template #rootItem let-item>
    <li style="margin-bottom: 8px;">
        <div class="checkboxItem" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
            <mat-checkbox style="font-weight: 500;" [class.selected]="shouldBeSelected(item)"
                [checked]="shouldBeSelected(item)" [indeterminate]="someComplete(item) && !allComplete(item)"
                (change)="itemChanged(item, $event.checked)">
                {{item.name}}
            </mat-checkbox>

            <!-- Master Expand/Collapse Arrow -->
            <span *ngIf="hasChildren(item)" (click)="expandCollapse(item)" style="cursor: pointer;">
                <mat-icon aria-hidden="false" aria-label="Expand/collapse icon"
                    *ngIf="item.collapsed;else isCollapsed">arrow_right</mat-icon>
                <ng-template #isCollapsed>
                    <mat-icon aria-hidden="false" aria-label="Expand/collapse icon">arrow_drop_down</mat-icon>
                </ng-template>
            </span>
        </div>

        <ng-container *ngIf="hasChildren(item) && !item.collapsed">
            <ul style="list-style: none; padding-left: 20px; margin: 8px 0 0 0;">
                <ng-container *ngFor="let itemChild of item.children">
                    <ng-container *ngTemplateOutlet="rootItem; context: {$implicit: itemChild}"></ng-container>
                </ng-container>
            </ul>
        </ng-container>
    </li>
</ng-template>